import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";
import dummyAadhar from "../../assets/img/Government1.jpg"; // Aadhaar replica image

const AadharXml = ({ isOpen, toggle, customerId }) => {
  const [aadharData, setAadharData] = useState(null);

  useEffect(() => {
  const fetchAadharData = async () => {
    try {
      const response = await axiosInstance.get(`${URL.GET_DOCUMENT_AADHAR}?customer_id=${customerId}`);
      const result = response.data;

      setAadharData(result);
    } catch (err) {
      console.error("Failed to fetch Aadhaar details", err);
    }
  };
    if (isOpen && customerId) {
      fetchAadharData();
    }
  }, [isOpen, customerId]);

  const issueDate = aadharData?.created_date
    ? aadharData.created_date.split("T")[0]
    : "-NA-";

  return (
    <>
      <style>{`
        .aadhar-replica-container {
          position: relative;
          width: 100%;
          height: 400px;
        }

        .aadhar-bg {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .aadhar-field {
          position: absolute;
          color: #000;
          font-size: 15px;
        }

        .aadhar-name {
          top: 137px;
          left: 160px;
          font-weight: bold;
        }

        .aadhar-gender {
          top: 177px;
          left: 160px;
        }

        .aadhar-dob {
          top: 157px;
          left: 160px;
        }

        .aadhar-number {
          bottom: 100px;
          left: 140px;
          font-size: 18px;
          font-weight: bold;
        }

         .aadhar-numberr {
          bottom: 100px;
          left: 540px;
          font-size: 18px;
          font-weight: bold;
        }

        .aadhar-address {
        top: 137px;
        left: 420px;
        width: 37%;
        line-height: 1.4;
        }

         .father-name {
          top: 157px;
          left: 419px;
        }

        .aadhar-photo {
          position: absolute;
          top: 137px;
          right: 657px;
          width: 99px;
          height: 100px;
          object-fit: cover;
          border: 1px  #ffffff;
        }

       .created-date {
        position: absolute;
        bottom: 135px;
        right: 425px;
        font-size: 10px;
        font-style: italic;
        color: #333;
        transform: rotate(90deg); 
        transform-origin: right bottom;
        }

    }

}
      `}</style>

      <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
        <ModalBody className="p-0">
          <div className="aadhar-replica-container">
            <img src={dummyAadhar} alt="Aadhaar Replica" className="aadhar-bg" />

            {aadharData && (
              <>
                <div className="aadhar-field aadhar-name">
                  {aadharData.name || "-NA-"}
                </div>
                <div className="aadhar-field aadhar-gender">
                  {aadharData.gender || "-NA-"}
                </div>
                <div className="aadhar-field aadhar-dob">
                  <strong> DOB: </strong>   
                  {aadharData.dob || "-NA-"}
                </div>
                <div className="aadhar-field aadhar-number">
                  {aadharData.uid || "-NA-"}
                </div>
                 <div className="aadhar-field aadhar-numberr">
                  {aadharData.uid || "-NA-"}
                </div>
                 <div className="aadhar-field aadhar-address">
                <strong>Address:</strong><br /> <br></br>
                {aadharData.address || "-NA-"}
                </div>
                <div className="aadhar-field father-name">
                    S/O:
                  {aadharData.father_name || "-NA-"} ,
                </div>
                 <div className="aadhar-field created-date">
                  Issue Date: {issueDate}
                </div>



                {/* Optional photo and QR code */}
                {aadharData.photo && (
  <img
    src={`data:image/jpeg;base64,${aadharData.photo}`}
    alt="User"
    className="aadhar-photo"
  />
)}

                {aadharData.qrCode && (
                  <img
                    src={aadharData.qrCode}
                    alt="QR Code"
                    className="aadhar-qr"
                  />
                )}
              </>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AadharXml;
